import { render } from "./_tokenRecover.vue?vue&type=template&id=4caefc08&scoped=true&ts=true"
import script from "./_tokenRecover.vue?vue&type=script&lang=ts"
export * from "./_tokenRecover.vue?vue&type=script&lang=ts"

import "./_tokenRecover.vue?vue&type=style&index=0&id=4caefc08&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caefc08"]])

export default __exports__